<template>
  <footer class="app-footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>广州星矩链动智能科技有限公司</h3>
          <p>专注于AI与软件技术，赋能传统行业智能化升级。</p>
        </div>
        <div class="footer-links">
          <h4>快速链接</h4>
          <ul>
            <li><router-link to="/">首页</router-link></li>
            <li><router-link to="/solutions">解决方案</router-link></li>
            <li><router-link to="/about">关于我们</router-link></li>
          </ul>
        </div>
        <div class="footer-contact">
          <h4>联系方式</h4>
          <p>地址：广州市天河区国际金融城</p>
          <p>合作咨询：ckcelio531@gmail.com</p>
        </div>
      </div>
      <div class="copyright">
        <p>Copyright © 2026. All Rights Reserved. 广州星矩链动智能科技有限公司 版权所有</p>
        <p>
          <a
            href="https://beian.miit.gov.cn"
            target="_blank"
            rel="noopener noreferrer"
          >备案号：粤ICP备2026042135号-1</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style lang="less" scoped>
.app-footer {
  background: linear-gradient(135deg, #0a0f14 0%, #0e141a 100%);
  color: #fff;
  padding: 80px 0 40px;
  font-family: 'PingFang SC', sans-serif;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at 80% 20%, rgba(255,255,255,0.05) 0%, transparent 40%);
    pointer-events: none;
  }

  .container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 30px;
    position: relative;
    z-index: 1;
  }

  .footer-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 60px;
    margin-bottom: 60px;
    border-bottom: 1px solid rgba(255,255,255,0.1);
    padding-bottom: 60px;

    .footer-section {
      flex: 2;
      min-width: 300px;

      h3 {
        font-size: 24px;
        margin-bottom: 25px;
        font-weight: 700;
        letter-spacing: 1px;
        background: linear-gradient(90deg, #fff, var(--accent));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      p {
        color: rgba(255, 255, 255, 0.7);
        line-height: 1.8;
        font-size: 16px;
        max-width: 400px;
      }
    }

    .footer-links, .footer-contact {
      flex: 1;
      min-width: 200px;

      h4 {
        font-size: 18px;
        margin-bottom: 30px;
        color: #fff;
        font-weight: 600;
        position: relative;
        display: inline-block;

        &::after {
            content: '';
            display: block;
            width: 40px;
            height: 3px;
            background: var(--accent);
            margin-top: 10px;
            border-radius: 2px;
        }
      }

      ul {
        list-style: none;
        padding: 0;

        li {
          margin-bottom: 15px;

          a {
            color: rgba(255, 255, 255, 0.7);
            text-decoration: none;
            font-size: 15px;
            transition: all 0.3s;
            display: inline-block;

            &:hover {
              color: var(--accent);
              transform: translateX(5px);
            }
          }
        }
      }

      p {
        color: rgba(255, 255, 255, 0.7);
        margin-bottom: 15px;
        font-size: 15px;
        display: flex;
        align-items: center;
        gap: 10px;

        &:hover {
          color: #fff;
        }
      }
    }
  }

  .copyright {
    text-align: center;
    color: rgba(255, 255, 255, 0.5);
    font-size: 14px;

    p {
      margin: 5px 0;
    }

    a {
      color: inherit;
      text-decoration: none;
      transition: color 0.3s;

      &:hover {
        color: var(--accent);
      }
    }
  }
}
</style>
